import { useState, useRef, useEffect } from 'react';
import { useDatabase } from '../hooks/useDatabase';
import { useSelector } from 'react-redux';
import { getTitleFromSummary } from '../utils/stringManipulate';
import { Link, Navigate } from 'react-router';
import sendEmail from '../hooks/useEmail';
import { useToast } from '../hooks/useToast';

const EmailMenu = ({ summaryData }) => {
  const [open, setOpen] = useState(false);
  const [emailInput, setEmailInput] = useState('');
  const [receiverEmails, setReceiverEmails] = useState([]);
  const [error, setError] = useState('');
  const { fetchUserSummary } = useDatabase();
  const { items } = useSelector(state => state.summary);
  const menuRef = useRef();

  const { showSuccess } = useToast();

  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;


  const toggleMenu = () => {
    setOpen(!open);
    fetchUserSummary();
  }

  const handleClickOutside = (e) => {
    if (menuRef.current && !menuRef.current.contains(e.target)) {
      setOpen(false);
    }
  };

  const handleClickAdd = () => {
    if (emailInput.trim() === '') return;
    
    const trimmed = emailInput.trim();

    if (!emailRegex.test(trimmed)) {
        setError('Invalid email format');
        return;
    } else setError('');
  
    const alreadyExists = receiverEmails.some(e => e.value === trimmed);
    if (alreadyExists) {
        setError('Email already added');
        return;
    } else setError('');

    const newEmail = {
      id: Date.now(),
      value: emailInput.trim(),
    };

    setReceiverEmails(prev => [...prev, newEmail]);
    setEmailInput('');
  }

  const handleRemoveEmail = (id) => {
    setReceiverEmails(prev => prev.filter(item => item.id !== id));
  };

  const handleSendEmail = () => {
    sendEmail(summaryData, receiverEmails);
    setOpen(false);
    showSuccess('Sent');
  }

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  return (
    <div ref={menuRef}>
        <div className="fixed left-10 top-42 z-40 bg-gray-100 border border-gray-300 p-2 rounded-xl backdrop-blur-md" onClick={toggleMenu}>
            <div className="relative">
                <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24" fill="none"><path d="M16.96 6.17c2 1.39 3.38 3.6 3.66 6.15M3.49 12.37a8.601 8.601 0 0 1 3.6-6.15M8.19 20.94c1.16.59 2.48.92 3.87.92 1.34 0 2.6-.3 3.73-.85M12.06 7.7a2.78 2.78 0 1 0 0-5.56 2.78 2.78 0 0 0 0 5.56ZM4.83 19.92a2.78 2.78 0 1 0 0-5.56 2.78 2.78 0 0 0 0 5.56ZM19.17 19.92a2.78 2.78 0 1 0 0-5.56 2.78 2.78 0 0 0 0 5.56Z" stroke="#777777" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path></svg>            
            </div>
        </div>
        {open && (
        <div className="fixed font-roboto max-w-full top-1/3 left-0 lg:left-1/3 lg:top-1/4 w-md lg:max-w-lg bg-white shadow-lg rounded-lg border border-gray-200 p-4 text-sm z-50 ease-in-out overflow-auto">
            {receiverEmails.length > 0 && <div className="absolute right-3 top-3 bg-green-400 p-2 rounded-xl cursor-pointer" onClick={handleSendEmail}>
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"><path stroke="#ffffff" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M13 11l8.2-8.2M22 6.8V2h-4.8M11 2H9C4 2 2 4 2 9v6c0 5 2 7 7 7h6c5 0 7-2 7-7v-2"></path></svg>
            </div> }
            <span class="text-xl font-semibold">Share</span>
            <div class="sm:flex mt-6">
                <input id="af-account-full-name" type="text" class={`py-1.5 px-3  w-full border ${error === '' ? 'border-gray-200' : 'border-red-400'} shadow-2xs first:rounded-t-lg last:rounded-b-lg sm:first:rounded-s-lg sm:first:rounded-se-none sm:last:rounded-es-none sm:last:rounded-e-lg sm:text-sm relative focus:z-10 focus:border-blue-500 focus:ring-blue-500 checked:border-blue-500 disabled:opacity-50 disabled:pointer-events-none`} 
                    placeholder="name@example.com" 
                    value={emailInput}
                    onChange={(e) => setEmailInput(e.target.value)}
                />
                <div onClick={handleClickAdd} class="py-1.5 sm:py-2 px-6 border border-gray-200 text-sm text-center lg:text-xl text-white font-medium cursor-pointer bg-blue-500 shadow-2xs -mt-px -ms-px first:rounded-t-lg last:rounded-b-lg sm:first:rounded-s-lg sm:mt-0 sm:first:ms-0 sm:first:rounded-se-none sm:last:rounded-es-none sm:last:rounded-e-lg sm:text-sm relative focus:z-10 focus:border-blue-500 focus:ring-blue-500 checked:border-blue-500 disabled:opacity-50 disabled:pointer-events-none" placeholder="Boone">
                    Add
                </div>
            </div>
            {error && <div class="text-sm text-red-400">{error}</div>}
            <div class="bg-gray-100 border rounded-md mt-4 border-gray-200 max-w-full w-full max-h-sm h-md">
                {receiverEmails.length > 0 ? (
                    receiverEmails.map((item) => (
                        <div key={item.id} className="flex justify-between items-center border border-gray-200 py-3 px-2">
                            <span class="text-gray-500">{item.value}</span>
                            <button
                                onClick={() => handleRemoveEmail(item.id)}
                                className="text-gray-500 text-sm cursor-pointer"
                            >
                                ✕
                            </button>
                        </div>
                    ))
                ) : (
                    <div className="text-gray-400 italic p-4">No emails added yet.</div>
                )}
            </div>
        </div>
        )}
    </div>
  );
};

export default EmailMenu;